import { type SavedFilter } from '@src/components/filter/components';

export interface Dimension {
  field: string;
  name: string;
  type: string;
  groupBy: string;
  category: string;
}

const isValidSavedFilter = (filter: SavedFilter, dimensions: Dimension[]) => {
  // empty filter should be valid
  if (!filter?.rule?.length) return true;

  const validDimensionSet = new Set(dimensions.map((it) => it.field));

  let validFilter = true;
  // check whether includes invalid dimensions
  for (const group of filter.rule) {
    for (const it of group) {
      if (!validDimensionSet.has(it.field)) {
        validFilter = false;
        break;
      }
    }
  }

  return validFilter;
};

export default isValidSavedFilter;
